import { UserInterface } from 'app/core/user/models';
import { EmployeeEquipmentWorkflowInterface, EquipmentCategoryInterface, EquipmentInterface } from 'app/equipment/models';
import { NotificationTemplateInterface } from 'app/notifications/models';
import { RecommendationInterface, RecommendationTemplateInterface } from 'app/recommendation/models';
import { RecommendationCategoryInterface } from 'app/recommendation/models/recommendation-category.model';
import { TrainingItemInterface } from 'app/training/models';

export function objectCompare(a: number | string | Date, b: number | string | Date, isAsc: boolean): number {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

export function sortTrainingItemsByTitle(trainingItems: TrainingItemInterface[], isAsc: boolean = true): TrainingItemInterface[] {
  return trainingItems.sort((a: TrainingItemInterface, b: TrainingItemInterface) => {
    const aTitle: string = a && a.title ? a.title.toLowerCase() : '';
    const bTitle: string = b && b.title ? b.title.toLowerCase() : '';
    return objectCompare(aTitle, bTitle, isAsc);
  });
}

export function sortNotificationItemsByTitle(notificationTemplates: NotificationTemplateInterface[],
                                             isAsc: boolean = true): NotificationTemplateInterface[] {
  return notificationTemplates.slice().sort((a: NotificationTemplateInterface, b: NotificationTemplateInterface) => {
    const aTitle: string = a.title.toLowerCase();
    const bTitle: string = b.title.toLowerCase();
    return objectCompare(aTitle, bTitle, isAsc);
  });
}

export function sortRecommendationItemsByTitle(recommendationItems: RecommendationTemplateInterface[],
                                               isAsc: boolean = true): RecommendationTemplateInterface[] {
  return recommendationItems.sort((a: RecommendationTemplateInterface, b: RecommendationTemplateInterface) => {
    return objectCompare('', '', isAsc);
  });
}

export function sortRecommendationCategoriesByTitle(recommendationItems: RecommendationCategoryInterface[],
                                                    isAsc: boolean = true): RecommendationCategoryInterface[] {
  return recommendationItems.slice().sort((a: RecommendationCategoryInterface, b: RecommendationCategoryInterface) => {
    const aTitle: string = a.title.toLowerCase();
    const bTitle: string = b.title.toLowerCase();
    return objectCompare(aTitle, bTitle, isAsc);
  });
}

export function sortRecommendationItemsById(recommendationItems: RecommendationInterface[],
                                            isAsc: boolean = false): RecommendationInterface[] {
  return recommendationItems.slice().sort((a: RecommendationInterface, b: RecommendationInterface) => {
    return objectCompare(a.id, b.id, isAsc);
  });
}

export function sortEquipmentItemsByTitle(trainingItems: EquipmentInterface[], isAsc: boolean = true): EquipmentInterface[] {
  return trainingItems.sort((a: EquipmentInterface, b: EquipmentInterface) => {
    const aTitle: string = a && a.title ? a.title.toLowerCase() : '';
    const bTitle: string = b && b.title ? b.title.toLowerCase() : '';
    return objectCompare(aTitle, bTitle, isAsc);
  });
}

export function sortUsersByFirstName(userItems: UserInterface[], isAsc: boolean = true): UserInterface[] {
  if(!userItems) { return; }
  return userItems.sort((a: UserInterface, b: UserInterface) => {
    const aTitle: string = a.firstName.toLowerCase();
    const bTitle: string = b.firstName.toLowerCase();
    return objectCompare(aTitle, bTitle, isAsc);
  });
}

export function sortEquipmentCategoriesTitle(
  trainingItems: EquipmentCategoryInterface[],
  isAsc: boolean = true): EquipmentCategoryInterface[] {
  return trainingItems.sort((a: EquipmentCategoryInterface, b: EquipmentCategoryInterface) => {
    const aTitle: string = a && a.title ? a.title.toLowerCase() : '';
    const bTitle: string = b && b.title ? b.title.toLowerCase() : '';
    return objectCompare(aTitle, bTitle, isAsc);
  });
}

export function sortEmployeeEquipmentWorkflowsByProp(
  workflows: EmployeeEquipmentWorkflowInterface[],
  sortProp: string,
  isAsc: boolean = true): EmployeeEquipmentWorkflowInterface[] {
  return workflows.sort((a: EmployeeEquipmentWorkflowInterface, b: EmployeeEquipmentWorkflowInterface) => {
    switch(sortProp) {
      case 'item': return objectCompare(a.equipmentItem.title.toLowerCase(),
                                        b.equipmentItem.title.toLowerCase(),
                                        isAsc);
      case 'category': return objectCompare(a.equipmentItem.equipmentCategoryLabel.toLowerCase(),
                                            b.equipmentItem.equipmentCategoryLabel.toLowerCase(),
                                            isAsc);
      case 'workArea': return objectCompare(a.equipmentItem.workAreaLabel.toLowerCase(),
                                            b.equipmentItem.workAreaLabel.toLowerCase(),
                                            isAsc);
      case 'installedDate': return objectCompare(a.equipmentItem.installedDate,
                                                 b.equipmentItem.installedDate,
                                                 isAsc);
      case 'recommendedDate': return objectCompare(a.equipmentItem.recommendedDate,
                                                   b.equipmentItem.recommendedDate,
                                                   isAsc);
      case 'status': return objectCompare(a.statusHistory[0].statusTypeLabel.toLowerCase(),
                                          b.statusHistory[0].statusTypeLabel.toLowerCase(),
                                          isAsc);
    }
  });
}

export function sortEmployeeRecommendationsByProp(
  workflows: RecommendationInterface[],
  sortProp: string,
  isAsc: boolean = true): RecommendationInterface[] {
  return workflows.sort((a: RecommendationInterface, b: RecommendationInterface) => {
    switch(sortProp) {
      case 'item': return objectCompare(a.title.toLowerCase(),
                                        b.title.toLowerCase(),
                                        isAsc);
      case 'priority': return objectCompare(a.priority,
                                            b.priority,
                                            isAsc);
      case 'recommendationDate': return objectCompare(a.recommendationDate,
                                                      b.recommendationDate,
                                                      isAsc);
      case 'completedDate': return objectCompare(a.completedDate,
                                                 b.completedDate,
                                                 isAsc);
      case 'daysOpen': return objectCompare(a.daysOpen,
                                            b.daysOpen,
                                            isAsc);
    }
  });
}
